module.exports = __webpack_public_path__ + "img/myself03-web.b28fc807.png";